import { render } from "./tournament-info.template.html?vue&type=template&id=71924963&scoped=true"
import script from "./TournamentInfo.vue?vue&type=script&lang=ts"
export * from "./TournamentInfo.vue?vue&type=script&lang=ts"

import "./TournamentInfo.vue?vue&type=style&index=0&id=71924963&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-71924963"

export default script